__turbopack_context__.v({
  "badgeIcon": "zINzcG_badgeIcon",
  "linkContainer": "zINzcG_linkContainer",
});
